export default class AlertProviderModule {
    provides() {
        return {
            'root-wrappers': [() => require('./withAlertProvider').default],
        };
    }
}
